import { Field } from 'ngx-angular-query-builder'
import { ITable, IRow } from '@common/models/table';
import {
  FieldMetadataCollectionBuilder,
  FilterOperators,
  FieldMetadata,
  FieldMetadataCollection,
  FilterFieldProvider,
  FilterListItem,
  FilterAvailabilityCallbacks
} from '@common/filter/filtering';
import { getMapCbk, labelSort, ArrayToFilterListItemBuilder } from '@common/filter/services/array-to-filter-list-item-builder';
import { ArrearsTransactionField, ArrearsTransactionFields } from '../services/arrears-transaction-fields.provider';

export class ArrearsTransactionFilterFieldProvider implements FilterFieldProvider {

  readonly fieldMetaDataCollection = new FieldMetadataCollection();
  private readonly arrearsFields= new ArrearsTransactionFields();

  constructor(
    private readonly table: ITable,
  ) {
    this.initialiseFields();
  }

  private initialiseFields() {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);
    const optionBuilder = new ArrayToFilterListItemBuilder(this.table.Rows);

    optionBuilder.forProperty('Age', 'SystemAge', (x: IRow) => x.SystemAge);
    optionBuilder.forProperty('Property', 'SystemProperty', (x: IRow) => x.SystemProperty);
    optionBuilder.add('Tenant', (x: IRow) => x.TenantRef, getMapCbk((x: IRow) => x.TenantRef, (x: IRow) => x.Tenant));
    optionBuilder.forProperty('Debtor', 'SystemDebtor', (x: IRow) => x.SystemDebtor);
    optionBuilder.forProperty('PropertyType', 'SystemPropertyType', (x: IRow) => x.SystemPropertyType);
    optionBuilder.forProperty('PropertyGroup', 'SystemPropertyGroup', (x: IRow) => x.SystemPropertyGroup);
    optionBuilder.forProperty('Location', 'SystemLocation', (x: IRow) => x.SystemLocation);
    optionBuilder.forProperty('PaymentPlan', 'SystemPaymentPlan', (x: IRow) => x.SystemPaymentPlan);
    optionBuilder.forProperty('SubLedger', 'SystemSubLedger', (x: IRow) => x.SystemSubLedger);

    const options = optionBuilder.build();

    fieldMetaDataBuilder.add(this.arrearsFields.age.label, 'SystemAge', 'category', FilterOperators.CategoryDefaults, options.get('SystemAge'));
    fieldMetaDataBuilder.add(this.arrearsFields.property.label, 'SystemProperty', 'category', FilterOperators.CategoryDefaults, options.get('SystemProperty'));
    fieldMetaDataBuilder.add(this.arrearsFields.tenant.label, 'SystemTenant', 'category', FilterOperators.CategoryDefaults, options.get('SystemTenant'));
    fieldMetaDataBuilder.add(this.arrearsFields.debtor.label, 'SystemDebtor', 'category', FilterOperators.CategoryDefaults, options.get('SystemDebtor'));
    fieldMetaDataBuilder.add(this.arrearsFields.propertyType.label, 'SystemPropertyType', 'category', FilterOperators.CategoryDefaults, options.get('SystemPropertyType'));
    fieldMetaDataBuilder.add(this.arrearsFields.propertyGroup.label, 'SystemPropertyGroup', 'category', FilterOperators.CategoryDefaults, options.get('SystemPropertyGroup'));
    fieldMetaDataBuilder.add(this.arrearsFields.location.label, 'SystemLocation', 'category', FilterOperators.CategoryDefaults, options.get('SystemLocation'));
    fieldMetaDataBuilder.add(this.arrearsFields.paymentPlan.label, 'SystemPaymentPlan', 'category', FilterOperators.CategoryDefaults, options.get('SystemPaymentPlan'));
    fieldMetaDataBuilder.add(this.arrearsFields.subLedger.label, 'SystemSubLedger', 'category', FilterOperators.CategoryDefaults, options.get('SystemSubLedger'));    

  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }


  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
